export default [
  { name: 'Name', prop: 'name', type: 'text' },
  { name: 'Start Date', prop: 'start_date', type: 'date' }
]
